import React from "react";
import { IModule } from "../Utils/Interface";
import Popover from "./Popover";
import { observer } from "mobx-react";

type Props = {
	addOn: IModule;
	onChange: (addOn: IModule) => void;
	isSelected: (addOn: IModule) => boolean;
};

type State = {
	isPopoverOpen: boolean;
};

@observer
class ModuleAddOns extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isPopoverOpen: false,
		};
	}

	handlePopover = (e: any) => {
		e.preventDefault();

		this.setState({ isPopoverOpen: !this.state.isPopoverOpen });

		if (!this.state.isPopoverOpen) {
			document.body.style.overflowY = "hidden";
		} else {
			document.body.style.overflowY = "unset";
		}
	};

	render() {
		const isSelected = this.props.isSelected(this.props.addOn);
		return (
			<label className={`multi-select-label addon`}>
				{this.state.isPopoverOpen && (
					<Popover
						headline={this.props.addOn.title}
						description={this.props.addOn.content}
						onClose={() => {
							this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
							if (!this.state.isPopoverOpen) {
								document.body.style.overflowY = "hidden";
							} else {
								document.body.style.overflowY = "unset";
							}
						}}
					/>
				)}
				<input
					type="checkbox"
					onChange={(e) => this.props.onChange(this.props.addOn)}
					className="multi-select-check-input"
					value={this.props.addOn.title}
					checked={isSelected}
				/>
				<span>{this.props.addOn.title}</span>
			</label>
		);
	}
}

export default ModuleAddOns;
